"use strict";

angular.module('PatientApp').controller('MyChartSSOCtrl', function ($scope, $rootScope, $filter, $state, $log, $timeout, PatientUsersService, ErrorsService, VuexStore, VueEventTransmitter) {
  var _reset = function _reset() {
    // attach this on an obj so
    // ng-include doesnt attach data to
    // a child scope
    $scope.findData = {};
  };

  _reset(); // initial state


  $scope.showingCheckEmail = false;
  $scope.showingEmailVerify = false;
  $scope.foundMatch = false;
  $scope.badVerificationAttempt = false;
  $scope.showingFinishRegistration = false;
  $scope.submittingFinishRegistration = false;
  $scope.forms = {
    myChartForm: {}
  };
  $scope.fields = {
    acceptTerms: false,
    email: '',
    verificationCode: ''
  };
  $scope.source = '';
  $scope.token = '';
  $scope.userFirstName = '';
  $scope.userLastName = '';
  $scope.finishRegistrationForm = {};
  $scope.finishRegistrationFields = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: ''
  };
  $scope.emailInput = {
    $invalid: false,
    $touched: false,
    $error: {}
  };
  $scope.codeSent = false;
  $scope.codeNotSent = false; // listeners

  $rootScope.$on('myChartSSO:showCheckEmail', function (_, source, token, userFirstName, userLastName) {
    $scope.welcomeMessage = $filter('translate')('myChartSSO.welcomeToPatientWallet', {
      providerGroupName: VuexStore.state.AppStore.brandingConfig.friendlyName
    });
    $scope.source = source;
    $scope.token = token;
    $scope.userFirstName = userFirstName;
    $scope.userLastName = userLastName;
    $scope.showingCheckEmail = true;
  });
  $rootScope.$on('myChartSSO:showFinishRegistration', function (_, data, callback) {
    $scope.showingFinishRegistration = true;
    $scope.finishRegistrationFields.firstName = data.firstName;
    $scope.finishRegistrationFields.lastName = data.lastName;
    $scope.finishRegistrationFields.email = data.email;
    $scope.userFirstName = $scope.finishRegistrationFields.firstName;
    $scope.callback = callback;
  }); // functions

  $scope.checkForPatientWalletAccount = function () {
    if ($scope.searching || $scope.forms.myChartForm.$invalid) {
      return;
    }

    $scope.searching = true;
    PatientUsersService.emailAvailable($scope.fields.email).then(function () {
      return $scope.sendVerification().then(function (resp) {
        if (resp.data && resp.data.error) {
          throw resp;
        }
      });
    }).then(function () {
      $scope.showingCheckEmail = false;
      $scope.searching = false;
      $scope.verifyEmailPrompt = $filter('translate')('myChartSSO.verifyEmail.noMatch.prompt', {
        email: $scope.fields.email
      });
      $scope.foundMatch = false;
      $scope.showingEmailVerify = true;
    }).catch(function (resp) {
      if (resp.data && resp.data.error) {
        // we encountered a known error
        $scope.sendVerificationError(resp.data.error);
      } else if (resp.errorCode) {
        // we got some other error we don't know how to handle
        $scope.handleErrorCode(resp);
      } else if (resp.data) {
        // there is a match, so continue to "confirm" step
        return $scope.sendVerification().then(function (resp) {
          if (resp.data && resp.data.error) {
            throw resp;
          }

          $scope.verifyEmailPrompt = $filter('translate')('myChartSSO.verifyEmail.foundMatch.prompt', {
            email: $scope.fields.email
          });
          $scope.foundMatch = true;
          $scope.showingCheckEmail = false;
          $scope.showingEmailVerify = true;
        }).catch(function (resp) {
          if (resp.data) {
            // we encountered a known error
            $scope.sendVerificationError(resp.data.error);
          } else if (resp.errorCode) {
            // we got some other error we don't know how to handle
            $scope.handleErrorCode(resp);
          }
        });
      }
    }).finally(function () {
      //in case there is a send verification error that is improperly handled
      $scope.searching = false;
    });
  };

  $scope.sendVerificationError = function (error) {
    if (error === 'LOGIN_BLOCKED') {
      // User entered an email already associated with another mychart sso user
      $scope.searching = false;
      $scope.emailInput.$invalid = true;
      $scope.emailInput.$error.alreadyLinked = true;
    } else if (error === 'INVALID_TOKEN') {
      // Token expired
      $scope.handleInvalidTokenError();
    }
  };

  $scope.handleInvalidTokenError = function () {
    $scope.verifying = false;
    $scope.showingCheckEmail = false;
    $scope.searching = false;
    $scope.showingEmailVerify = false;
    VueEventTransmitter.$emit('simpleModal:showPrompt', {
      header: $filter('translate')('myChartSSO.error.invalidToken'),
      subcontent: $filter('translate')('myChartSSO.error.body'),
      intent: 'error',
      actions: [{
        label: $filter('translate')('myChartSSO.error.backToMyChart'),
        clickHandler: function clickHandler() {
          $scope.returnToReferrer();
        }
      }]
    });
  };

  $scope.handleErrorCode = function (resp) {
    // we got some other error we don't know how to handle
    $log.error('Error checking email', resp);
    $scope.verifying = false;
    $scope.showingCheckEmail = false;
    $scope.searching = false;
    VueEventTransmitter.$emit('simpleModal:showPrompt', {
      header: $filter('translate')('myChartSSO.error.header'),
      subcontent: $filter('translate')('myChartSSO.error.body'),
      intent: 'error',
      actions: [{
        label: $filter('translate')('myChartSSO.error.backToMyChart'),
        clickHandler: function clickHandler() {
          $scope.returnToReferrer();
        }
      }]
    });
  };

  $scope.verifyEmail = function () {
    if ($scope.verifying) {
      return;
    }

    $scope.badVerificationAttempt = false;

    if ($scope.foundMatch) {
      $scope.verifying = true;
      return PatientUsersService.confirmSSOVerifyCode($scope.fields.email, $scope.fields.verificationCode, $scope.source, $scope.token).then(function (result) {
        $scope.verifying = false;

        if (result.data.success === false) {
          if (result.data.error && result.data.error === 'INVALID_TOKEN') {
            $scope.handleInvalidTokenError();
          } else {
            $scope.source = result.data.source;
            $scope.token = result.data.token;
            $scope.badVerificationAttempt = true;
          }
        } else {
          return PatientUsersService.fetchUser().then(function () {
            $scope.showingEmailVerify = false;
            $state.go('app.dashboard', null, {
              location: 'replace'
            });
            VueEventTransmitter.$emit('simpleModal:showPrompt', {
              header: $filter('translate')('myChartSSO.verifyEmail.foundMatch.success.header'),
              subcontent: $filter('translate')('myChartSSO.verifyEmail.foundMatch.success.prompt'),
              intent: 'success',
              actions: [{
                label: $filter('translate')('actions.continue'),
                includeClasses: 'continue-button'
              }]
            });
          });
        }
      }).catch(function (err) {
        $log.error('Error while trying to confirm MyChartSSO', err);
        VueEventTransmitter.$emit('simpleModal:showPrompt', {
          header: $filter('translate')('myChartSSO.error.header'),
          subcontent: $filter('translate')('myChartSSO.error.body'),
          intent: 'error',
          actions: [{
            label: $filter('translate')('myChartSSO.error.backToMyChart'),
            clickHandler: function clickHandler() {
              $scope.returnToReferrer();
            }
          }]
        });
      });
    } else {
      if (!$scope.fields.acceptTerms) {
        // TODO: Add real error here
        return;
      }

      $scope.verifying = true;
      $scope.badVerificationAttempt = false;
      return PatientUsersService.registerSSOUser($scope.fields.email, $scope.fields.verificationCode, $scope.fields.acceptTerms, $scope.source, $scope.token).then(function (result) {
        $scope.verifying = false;

        if (result.errorCode) {
          throw new Error('something went wrong during registration', result);
        } else if (result.data && result.data.success === false) {
          if (result.data.error && result.data.error === 'INVALID_TOKEN') {
            $scope.handleInvalidTokenError();
          } else {
            $scope.source = result.data.source;
            $scope.token = result.data.token;
            $scope.badVerificationAttempt = true;
          }
        } else {
          return PatientUsersService.fetchUser().then(function () {
            $scope.showingEmailVerify = false;
            $state.go('app.dashboard', null, {
              location: 'replace'
            });
            VueEventTransmitter.$emit('simpleModal:showPrompt', {
              header: $filter('translate')('myChartSSO.verifyEmail.noMatch.success.header'),
              subcontent: $filter('translate')('myChartSSO.verifyEmail.noMatch.success.prompt'),
              intent: 'success',
              actions: [{
                label: $filter('translate')('actions.continue'),
                includeClasses: 'continue-button'
              }]
            });
          });
        }
      }).catch(function (err) {
        $log.error('Error while registering SSO user', err);
        VueEventTransmitter.$emit('simpleModal:showPrompt', {
          header: $filter('translate')('myChartSSO.error.header'),
          subcontent: $filter('translate')('myChartSSO.error.body'),
          actions: [{
            label: $filter('translate')('myChartSSO.error.backToMyChart'),
            clickHandler: function clickHandler() {
              $scope.returnToReferrer();
            }
          }]
        });
      });
    }
  };

  $scope.sendVerification = function () {
    return PatientUsersService.myChartSSOSendVerification($scope.fields.email, $scope.userFirstName, $scope.source, $scope.token).then(function (resp) {
      $scope.source = resp.data.source;
      $scope.token = resp.data.token;
      return resp;
    });
  };

  $scope.resendVerification = function () {
    return PatientUsersService.myChartSSOSendVerification($scope.fields.email, $scope.userFirstName, $scope.source, $scope.token).then(function (resp) {
      if (resp.data && resp.data.error) {
        throw resp;
      }

      $scope.source = resp.data.source;
      $scope.token = resp.data.token;
      $scope.codeSent = true;
      $timeout(function () {
        $scope.codeSent = false;
      }, 5000);
    }).catch(function (resp) {
      if (resp.data && resp.data.error) {
        if (resp.data.error === 'INVALID_TOKEN') {
          $scope.handleInvalidTokenError();
        }
      }

      $scope.codeNotSent = true;
      $timeout(function () {
        $scope.codeNotSent = false;
      }, 5000);
    });
  };

  $scope.useDifferentEmail = function () {
    $scope.showingEmailVerify = false;
    $scope.showingCheckEmail = true;
  };

  $scope.finishRegistration = function () {
    if ($scope.submittingFinishRegistration) {
      return;
    }

    var registerInfo = {
      email: $scope.finishRegistrationFields.email,
      password: $scope.finishRegistrationFields.password,
      receivesSms: $scope.finishRegistrationFields.receivesSms,
      confirmPassword: $scope.finishRegistrationFields.confirmPassword,
      firstName: $scope.finishRegistrationFields.firstName,
      lastName: $scope.finishRegistrationFields.lastName,
      phoneNumber: $scope.finishRegistrationFields.phoneNumber
    };
    $scope.submittingFinishRegistration = true;
    PatientUsersService.register(registerInfo).then(function () {
      $scope.showingFinishRegistration = false;
      $scope.callback().then(function () {
        VueEventTransmitter.$emit('simpleModal:showPrompt', {
          header: $filter('translate')('myChartSSO.finishRegistration.success.header'),
          subcontent: $filter('translate')('myChartSSO.finishRegistration.success.prompt'),
          intent: 'success',
          actions: [{
            label: $filter('translate')('actions.continue'),
            includeClasses: 'continue-button'
          }]
        });
        $scope.submittingFinishRegistration = false;
      });
    }).catch(function (resp) {
      switch (ErrorsService.resolve(resp)) {
        case ErrorsService.errors.LOGIN_NOT_VERIFIED:
          $scope.showingFinishRegistration = false;
          VueEventTransmitter.$emit('verification:prompt', {
            email: $scope.finishRegistrationFields.email,
            callback: $scope.callback
          });
      }

      $scope.submittingFinishRegistration = false;
    });
  };

  $scope.touchedCheckEmail = function () {
    $scope.emailInput.$touched = true;
    $scope.emailInput.$invalid = false;
  };
});